import ImageWIthSignedUrl from "components/S3Utility/ImageWIthSignedUrl";

/**
 * Courier helpers for Tracking Info (formerly Ups Tracking).
 * Design: docs/superpowers/specs/2026-10-15-tracking-info-design.md
 *
 * Each row arrives from the API with `courier` = { id, name, logo,
 * trackingUrl } -- its own courier, else the company's UPS tracker -- or null
 * when the company has not marked a UPS tracker yet.
 */

// The link this page has always built. Every row was UPS until couriers
// existed, so it stays the fallback for a courier with no tracking URL set:
// nothing stops working before Settings -> Couriers is filled in.
export const UPS_FALLBACK_URL = (trackingNumber) =>
  `https://wwwapps.ups.com/WebTracking?loc=en_US&TypeOfInquiryNumber=T&Requester=WS&InquiryNumber1=${trackingNumber}&/trackdetails`;

// The courier's URL with the tracking number appended (Settings: "the app
// appends the tracking number"), else the UPS link above.
export const trackingUrlFor = (item) => {
  const tn = encodeURIComponent(item?.trackingNumber ?? "");
  const base = item?.courier?.trackingUrl;
  return base ? `${base}${tn}` : UPS_FALLBACK_URL(tn);
};

// Whether a courier's tracking can be read from an API -- the same rule as the
// API's services/courierTracking.js: its Tracking API, else a dhl.com /
// ups.com tracking URL. Decides whether Details is offered on a row.
export const hasTrackingApi = (courier) => {
  if (!courier) return false;
  if (courier.trackingProvider) return true;
  let host = "";
  try {
    host = new URL(String(courier.trackingUrl || "").trim()).hostname.toLowerCase();
  } catch {
    return false;
  }
  return ["dhl.com", "ups.com"].some((d) => host === d || host.endsWith(`.${d}`));
};

export function CourierCell({ courier }) {
  if (!courier) return <span className="text-muted">—</span>;
  return (
    // Name first, then a small logo after it (user, 2026-10-15).
    <div className="d-flex align-items-center gap-1" title={courier.name || ""}>
      <span>{courier.name || "—"}</span>
      {courier.logo && (
        <div style={{ width: 28, flex: "0 0 28px" }}>
          <ImageWIthSignedUrl
            path={courier.logo}
            alt={`${courier.name || "Courier"} logo`}
            imgStyle={{ maxHeight: 16, width: "auto", objectFit: "contain" }}
          />
        </div>
      )}
    </div>
  );
}
